export const FOOTER_TEXT = {
    contacts: {title: 'Контакты'},
    hotLine: {title: 'Горячая линия'},
    payments: {title: 'Принимаем к оплате'},
} as const;

export const APP_STORE_LINK = 'https://redirect.appmetrica.yandex.com/serve/317562624831209857';

export const GOOGLE_PLAY_LINK = 'https://redirect.appmetrica.yandex.com/serve/605792806383990082';
